<template>
    <b-form @submit.prevent="update" v-if="details">
        <b-row class="mt-5">
            <b-col sm="12" md="2"
                :class="{'col-md-3 text-left': isSetup}"><h6 class="align-middle">Points</h6></b-col>
            <b-col sm="12" md="7"
                :class="{'col-md-9': isSetup}">
                <div class="mb-5"
                    :class="{'text-left': isSetup}">
                    <div style="margin-top: 1px;">
                        <span class="label-helper align-top">Earning</span>
                        <i class="guide-tooltip" id="earning-guide"></i>
                        <b-popover target="earning-guide" triggers="hover" content="Nominate the minimum transaction value and equivalent points that customers can earn."></b-popover>
                    </div>
                    <div class="form-container">
                        <b-row no-gutters>
                            <b-col cols="7">
                                <b-row><b-col><span class="d-block mb-2 up-label">Currency</span></b-col></b-row>
                                <b-row no-gutters>
                                    <b-col cols="1"><i class="icon d-block" style="margin-top: 9px;"><img src="@/assets/images/mechanics/currency.svg" alt="Currency Icon"></i></b-col>
                                    <b-col class="p-1"><b-form-select v-model="details.currency" :options="currencyOptions" :disabled="!isEnabledPointsEarning" /></b-col>
                                    <b-col class="p-1">
                                        <b-form-group :invalid-feedback="errors.amount" :state="isValid('amount')">
                                            <b-form-input type="number" :formatter="pointsFormatter" placeholder="0" min="1" value="0" step="1" v-model="details.amount" :disabled="!isEnabledPointsEarning"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="1">
                                <i class="icon mx-auto d-block" style="margin-top: 4px;"><img src="@/assets/images/mechanics/convert.svg" alt="Convert Icon" style="margin-top: 36px;"></i>
                            </b-col>
                            <b-col>
                                <b-row><b-col><span class="d-block mb-2 up-label">Points</span></b-col></b-row>
                                <b-row no-gutters>
                                    <b-col cols="2"><i class="icon d-block" style="margin-top: 9px;"><img src="@/assets/images/mechanics/points.svg" alt="Points Icon"></i></b-col>
                                    <b-col class="py-1">
                                        <b-form-group :invalid-feedback="errors.points" :state="isValid('points')">
                                        <b-form-input type="number" :formatter="pointsFormatter" value="1" disabled="disabled"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div class="mb-5"
                    :class="{'text-left': isSetup}">
                    <div style="margin-top: 1px;">
                        <span class="label-helper align-top">Pay with Points</span>
                        <i class="guide-tooltip" id="redemption-guide"></i>
                        <b-popover target="redemption-guide" triggers="hover" content="Nominate the minimum points required and the equivalent monetary value that customers can use as payment."></b-popover>
                    </div>
                    <div class="form-container">
                        <b-row no-gutters>
                            <b-col>
                                <b-row><b-col><span class="d-block mb-2 up-label">Points</span></b-col></b-row>
                                <b-row no-gutters>
                                    <b-col cols="2"><i class="icon d-block" style="margin-top: 9px;"><img src="@/assets/images/mechanics/points.svg" alt="Points Icon"></i></b-col>
                                    <b-col class="py-1">
                                        <b-form-group :invalid-feedback="errors.redeem_amount" :state="isValid('redeem_amount')">
                                            <b-form-input type="number" :formatter="pointsFormatter" value="1" disabled="disabled"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="1"><i class="icon mx-auto d-block" style="margin-top: 4px;"><img src="@/assets/images/mechanics/convert.svg" alt="Convert Icon" style="margin-top: 36px;"></i></b-col>
                            <b-col cols="7">
                                <b-row><b-col><span class="d-block mb-2 up-label">Currency</span></b-col></b-row>
                                <b-row no-gutters>
                                    <b-col cols="1"><i class="icon d-block" style="margin-top: 9px;"><img src="@/assets/images/mechanics/currency.svg" alt="Currency Icon"></i></b-col>
                                    <b-col class="p-1"><b-form-select v-model="details.redeem_currency" :options="currencyOptions" :disabled="!isEnabledPointsEarning" /></b-col>
                                    <b-col class="p-1">
                                        <b-form-group :invalid-feedback="errors.redeem_amount" :state="isValid('redeem_amount')">
                                            <b-form-input type="number" :formatter="pointsFormatter" placeholder="0" min="1" step="1" v-model="details.redeem_amount" :disabled="!isEnabledPointsEarning"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div class="mb-5"
                    :class="{'text-left': isSetup}">
                    <b-row>
                        <b-col cols="4">
                            <span class="sl-helper d-block mb-1">Points Expiry</span>
                            <switches
                                id="toggle-points-expiry"
                                v-model="details.expiration"
                                theme="custom"
                                color="primary"
                                type-bold="true"
                                style="top: -8px;"
                                text-enabled="On"
                                text-disabled="Off">
                            </switches>
                        </b-col>
                        <b-col cols="4">
                            <b-form-group :invalid-feedback="errors.validity" :state="isValid('validity')">
                                <span class="sl-helper d-block mb-1">Validity</span>
                                <b-form-select
                                    v-model="details.validity"
                                    :options="validityOptions"
                                    text-enabled="On"
                                    text-disabled="Off"
                                    :disabled="!details.expiration"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <!--
                <div class="mb-4">
                    <b-row>
                        <b-col cols="8">
                            <b-form-group id="membership"
                                          label="Membership"
                                          label-for="membership" class="sl-helper">
                                <b-form-select id="membership"
                                               :options="membershipOptions"
                                               required>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                -->
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="9"
                :class="{'col-12': isSetup}"><hr></b-col>
            <b-col></b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col sm="12" md="2"
                :class="{'col-md-3 text-left': isSetup}">
                <h6 class="align-middle">Description</h6>
            </b-col>
            <b-col sm="12" md="7"
                :class="{'col-md-9': isSetup}">
                <b-row>
                    <b-col cols="8"
                        :class="{'col-12 text-left': isSetup}">
                        <b-form-group
                            label-for="productDescription"
                            class="sl-helper"
                            :label="descriptionLabel"
                        >

                            <b-form-textarea
                                id="productDescription"
                                v-model="details.description"
                                placeholder="Enter description"
                                :rows="3"
                                :maxlength="descriptionMaxLength"
                                :max-rows="6"
                            >
                            </b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col></b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="9"
                :class="{'col-12': isSetup}"><hr></b-col>
            <b-col></b-col>
        </b-row>
        <b-row class="mt-3 mb-3 " :class="planId == 1 || planId == 2 ? 'disableContent' :''">
            <b-col sm="12" md="2"
                :class="{'col-md-3 text-left': isSetup}">
                    <h6 class="align-middle" v-b-tooltip.hover 
                    :title="planId == 1 || planId == 2 ? unavailableToPlan : ''">
                        Transfer Points
                    </h6>
            </b-col>
            <b-col sm="12" md="7"
                :class="{'col-md-9': isSetup}">
                <b-row>
                    <b-col cols="8"
                        :class="{'text-left': isSetup}"><switches id="toggle-transfer-points" v-model="details.transfer_points" theme="custom" color="primary" type-bold="true" style="margin-top: 6px;"
                        :class="{'mt-4 mb-0': isSetup}" :disabled="planId == 1 || planId == 2 ? true : false"></switches></b-col>
                    <b-col></b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="9"
                :class="{'col-12': isSetup}"><hr></b-col>
            <b-col></b-col>
        </b-row>
        <b-row class="mt-3 mb-3" v-if="planId != 1 && planId != 2">
            <b-col sm="12" md="2"
                :class="{'col-md-3 text-left': isSetup}"><h6 class="align-middle">Require OR Image</h6></b-col>
            <b-col sm="12" md="7"
                :class="{'col-md-9': isSetup}">
                <b-row>
                    <b-col cols="8"
                        :class="{'text-left': isSetup}"><switches id="toggle-require-or-image" v-model="details.or_required" theme="custom" color="primary" type-bold="true" style="margin-top: 6px;"
                        :class="{'mt-4 mb-0': isSetup}"></switches></b-col>
                    <b-col></b-col>
                </b-row>
            </b-col>
        </b-row>
        <!-- <b-row>
            <b-col cols="9"
                :class="{'col-12': isSetup}"><hr></b-col>
            <b-col></b-col>
        </b-row> -->
        <!-- Commented temprarily for future use
             <b-row class="mt-3 mb-3">
            <b-col sm="12" md="2"
                :class="{'col-md-3 text-left': isSetup}"><h6 class="align-middle">Max Points</h6></b-col>
            <b-col sm="12" md="7">
                <b-row>
                    <b-col cols="8">
                        <b-form-input type="number" placeholder="0" v-model="details.max_points"></b-form-input>
                    </b-col>
                    <b-col></b-col>
                </b-row>
            </b-col>
        </b-row> -->
        <!-- <b-row>
            <b-col cols="9" :class="{'col-12': isSetup}">
                <hr>
            </b-col>
            <b-col></b-col>
        </b-row> -->
        <b-row
            :class="{'d-inline-flex': isSetup}">
            <b-col><b-button size="lg" variant="primary" v-bind:disabled="loading" class="mt-4" type="submit" :block="true"
            :class="{'save-button': !isSetup, 'mx-auto submit-button': isSetup, 'btn-submitted': submittedbtn}">
                <template v-if="!isSetup">
                    <template v-if="loading">
                        Saving...
                    </template>
                    <template v-else>
                        Save
                    </template>
                </template>
                <template v-else>
                    <template v-if="submittedbtn">
                        <img src="../../assets/images/setup/check-done.svg" class="mr-2"> Submitted
                    </template>
                    <template v-else>
                        Submit
                    </template>
                </template>
            </b-button></b-col>
            <b-col cols="10"></b-col>
        </b-row>
    </b-form>
</template>

<script>
import Switches from "vue-switches-2";
import { mapState, mapGetters } from "vuex";

export default {
    name: "PointsContent",
    props: ["isSetup"],
    data() {
        return {
            membershipOptions: ["100", "200", "300", "400"],
            currencyOptions: ["PHP", "USD"],
            validityOptions: [
                { value: "+3 months", text: "3 Months" },
                { value: "+6 months", text: "6 Months" },
                { value: "+1 year", text: "1 Year" },
                { value: "+2 years", text: "2 Years" },
                { value: "+3 years", text: "3 Years" },
                { value: "+4 years", text: "4 Years" },
                { value: "+5 years", text: "5 Years" },
                { value: "+10 years", text: "10 Years" },
                { value: "+15 years", text: "15 Years" }
            ],
            submittedbtn: false,
            descriptionMaxLength: 1000
        };
    },
    components: {
        Switches
    },
    computed: {
        ...mapState("points", ["loading", "details", "errors"]),
        ...mapState("auth", ["planId", "unavailableToPlan"]),
        ...mapGetters("estoreSettings", ["isEnabledPointsEarning"]),
        descriptionLabel: {
            get: function() {
                if (this.details.description != null) {
                    return (
                        this.details.description.length +
                        " / " +
                        this.descriptionMaxLength
                    );
                }
                return "0 / " + this.descriptionMaxLength;
            }
        }
    },

    created() {
        this.$store.dispatch("estoreSettings/viewSettings")
        this.$store.dispatch("points/getDetails");
    },

    methods: {
        validate() {
            const errors = {};
            const requiredFieldSpiel = "This field is required.";
            this.$store.commit("points/errors", {});
            
            if (this.details.expiration && !this.details.validity) {
                errors.validity = requiredFieldSpiel
            }

            this.$store.commit("points/errors", { ...this.errors, ...errors });
        },
        update() {
            this.validate();

            if (!Object.keys(this.errors).length) {
                this.$store.dispatch("points/updateDetails");
                this.$emit("submitted", true);
                this.submittedbtn = true;
            }
        },
        isValid(field) {
            return this.errors[field] ? false : true;
        },
        pointsFormatter(value, event) {
            return event === null ? value : value * 1;
        }
    },
    watch: {
        "details.expiration"(value) {
            if (!value) this.details.validity = null;
        }
    }
};
</script>

<style scoped>
h6 {
    font-family: MainFontBold, sans-serif;
    font-size: 16px;
}
</style>
